import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-check-list-item-tw',
  templateUrl: './check-list-item-tw.component.html',
  styleUrls: ['./check-list-item-tw.component.css']
})
export class CheckListItemTwComponent implements OnInit {
    argType;

    argValue;

    public checkListItemTwKeyno: string;

    public edit?: Edit;

    public selectListLinksToForms: Item[] = [];

    public selectListLinksToQuestions: Item[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
        this.checkListItemTwKeyno = this.stateService.getStateParams()['checklistitemtw_keyno'];
    }

    private async loadEdit() {
        if (!!this.argType && !!this.argValue && !!this.checkListItemTwKeyno) {
            this.edit = (await this.datatask.Post(1566, {
                argtype: this.argType,
                argvalue: this.argValue,
                checklistitemtw_keyno: this.checkListItemTwKeyno
            }))[0];
        }
    }

    private async loadLinksToForms() {
        this.selectListLinksToForms = await this.datatask.Post(1567);
    }

    private async loadLinksToQuestions() {
        if (!this.edit) return;

        return this.selectListLinksToQuestions = await this.datatask.Post(1568, { checklist_keyno: this.edit.checklist_keyno });
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1569, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(1571, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'checklist_keyno':
                this.loadLinksToQuestions();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadLinksToForms();
        this.loadLinksToQuestions();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    checklistitemtw_keyno: string;
    travelwage_id: string;
    checklist_keyno: string;
    checklistitem_keyno: string;
    travelwage_name: string;
}
